<template>
  <!-- <v-container> -->
    <!-- <v-row> -->
      <!-- <v-col cols="12"> -->
        <v-card>
          <!-- <v-card-title>
            經費需求申請期程
          </v-card-title> -->
          <v-card-subtitle>
            <v-row class="mt-2 py-1">
              <v-col cols="3">
                <v-select :items="years" label="所屬年度" item-title="rocYear" item-value="adYear" v-model="filters.year" clearable></v-select>
              </v-col>
              <v-col cols="3">
                <v-select :items="eventSelections" label="亞奧運、世大運" item-title="title" item-value="value" v-model="filters.event" clearable></v-select>
              </v-col>
              <v-col cols="3">
              </v-col>
              <v-col cols="3" class="d-flex justify-end">
                <!-- @click="downloadExcel" -->
                <v-btn color="primary" variant="tonal" class="mr-2"  @click="exportControlSheet" :loading="buttonStatus.exportControlSheetLoading">
                  管控表
                  <v-tooltip activator="parent">
                    下載
                    {{(filters.year??new Date().getFullYear())-1911}}年度
                    {{filters.event?eventSelections.find((it)=>it.value==filters.event).title:'亞、奧運'}}
                    管控表
                  </v-tooltip>  
                </v-btn>
                <!-- @click="downloadPDF" -->
                <v-btn color="secondary" variant="tonal"  @click="exportOverviewSheet" :loading="buttonStatus.exportOverviewSheetLoading">
                  概況表
                  <v-tooltip activator="parent">
                  下載 {{(filters.year??new Date().getFullYear())-1911}}年度 概況表
                  </v-tooltip>
                </v-btn>
              </v-col>
            </v-row>
          </v-card-subtitle>
          
          <!-- <v-data-table
          :headers="headers"
          :items="budgetList"
          > -->
          <!-- <template v-slot:item.borrowApplyNo="{ item }">
            <a style="cursor: pointer;"  @click="goto(item)">{{item.borrowApplyNo}}</a>
          </template> -->
        <!-- </v-data-table> -->
          <v-data-table :headers="headers" :items="budgetList" class="elevation-1" no-data-text="尚無資料">
            <template v-slot:item.id="{ item ,index}">
              {{index+1}}
            </template>
            <template v-slot:item.sendedDate="{ item ,index}">
              {{item.sendedDate?convertToTaiwanYear(item.sendedDate,'-'):""}}
            </template>
            <template v-slot:item.reviewDate="{ item ,index}">
              {{item.reviewDate?convertToTaiwanYear(item.reviewDate,'-'):""}}
            </template>
            <template v-slot:item.recheckDate="{ item ,index}">
              {{item.recheckDate?convertToTaiwanYear(item.recheckDate,'-'):""}}
            </template>
            <template v-slot:item.resubmitedDate="{ item ,index}">
              {{item.resubmitedDate?convertToTaiwanYear(item.resubmitedDate,'-'):""}}
            </template>
            <template v-slot:item.fundApprovedDate="{ item ,index}">
              {{item.fundApprovedDate?convertToTaiwanYear(item.fundApprovedDate,'-'):""}}
            </template>
            <template v-slot:item.finalSendDate="{ item ,index}">
              {{item.finalSendDate?convertToTaiwanYear(item.finalSendDate,'-'):""}}
            </template>
            <template v-slot:item.totalApprovedAmount="{ item ,index}">
              {{Number(item.totalApprovedAmount).toLocaleString()}}
            </template>
            <template v-slot:item.trainingAmount="{ item ,index}">
              {{Number(item.trainingAmount).toLocaleString()}}
            </template>
            <template v-slot:item.personnelAmount="{ item ,index}">
              {{Number(item.personnelAmount).toLocaleString()}}
            </template>
            <template v-slot:item.consumableEquipmentAmount="{ item ,index}">
              {{Number(item.consumableEquipmentAmount).toLocaleString()}}
            </template>
            <template v-slot:item.capitalEquipmentAmount="{ item ,index}">
              {{Number(item.capitalEquipmentAmount).toLocaleString()}}
            </template>
            <template v-slot:item.AnnualFeeAmount="{ item ,index}">
              {{Number(item.AnnualFeeAmount).toLocaleString()}}
            </template>
          </v-data-table>
        </v-card>
</template>

<script setup lang="ts">
import {onMounted, reactive} from "vue"
definePage({
  meta: {
    action: 'manage', //固定為 manage
    subject: 'ASSOCIATIONBUDGETSCHEDULE', //系統代碼(系統授權設定中的系統代碼)
  },
})
const filters= reactive({
  year:null,
  event:null,
})

const { data: yearList, execute: fetchFilterYearList } = await useApi<any>(createUrl('/tca/expenserequestprojectlist/getYear', {
}))
const eventSelections=[{title:'亞、奧運',value:'team'},{title:'黃金選手',value:'gold'}];
const years = computed(() => yearList ? yearList.value.data : []);
const search=reactive('')
const headers=[
  { title: '#', value: 'id' },
  { title: '協會', value: 'deptName' },
  { title: '提交申請', value: 'sendedDate' },
  { title: '審查會議', value: 'reviewDate' },
  { title: '回饋會議記錄', value: 'recheckDate' },
  { title: '函送修正計畫及預算', value: 'resubmitedDate' },
  { title: '經費核定', value: 'fundApprovedDate' },
  { title: '備查', value: 'finalSendDate' },
  { title: '函送核定金額', value: 'totalApprovedAmount' , align:'end'},
  { title: '移訓、參賽核定數', value: 'trainingAmount' , align:'end'},
  { title: '人事核定金額', value: 'personnelAmount' , align:'end'},
  { title: '消耗器材核定數', value: 'consumableEquipmentAmount' , align:'end'},
  { title: '資本門核定數', value: 'capitalEquipmentAmount' , align:'end'},
  { title: '年度費用', value: 'AnnualFeeAmount' , align: 'end' },
]
const items=reactive([
  { id: 1, association: '田徑', submitDate: '2023/12/6', reviewMeeting: '2023/12/18', feedbackRecord: '2023/12/25', revisedPlan: '2024/1/12', fundingApproval: '2024/3/21', revisedFunding: '2024/4/1', trainingApproval: '5,238,520', equipmentApproval: '549,460' },
  { id: 2, association: '游泳', submitDate: '2023/11/24', reviewMeeting: '2023/12/22', feedbackRecord: '2023/12/25', revisedPlan: '2024/1/24', fundingApproval: '2024/3/21', revisedFunding: '2024/4/11', trainingApproval: '14,687,010', equipmentApproval: '510,028' },
])
const page=ref(1)
const pageCount= ref(2)
const fileUrl = useStorage("drFsUrl").value;

const budgetList = reactive([]);

const popSwal = (icon,title,text) => {
  if(icon=="success"){
    $swal({
      position: 'top-end',
      icon: icon,
      title: title,
      text: text,
      showConfirmButton: false,
      timer: 1500,
      customClass: {
        confirmButton: 'btn btn-primary',
      },
      buttonsStyling: false,
    });
  }else if (icon=="error"){
    $swal({
      position: 'top-end',
      icon: icon,
      title: title,
      text: text,
      showConfirmButton: false,
      // timer: 1500,
      customClass: {
        confirmButton: 'btn btn-primary',
      },
      buttonsStyling: false,
    });
  }else{
    $swal({
      position: 'top-end',
      icon: icon,
      title: title,
      text: text,
      showConfirmButton: false,
      // timer: 1500,
      customClass: {
        confirmButton: 'btn btn-primary',
      },
      buttonsStyling: false,
    });
  }
}

const getBudgetSchedule = async () => {
  let year = filters.year?filters.year:null
  let event = filters.event?filters.event:null
  try {
    const response = await $api('/tca/budgetSchedule/get', {
      method: 'POST',
      body: {
          belongYear: year,
          scheType: event,
      },
    });
    // 检查响应的结构
    if (response && response.data && response.data.length > 0) {
      budgetList.splice(0, budgetList.length, ...response.data);
    } else {
      // 没有数据或错误情况
      budgetList.splice(0, budgetList.length);  // 清空 applicants
      console.error('Fetch error: no data received or response structure unexpected');
    }
  } catch (error) {
    console.error('Error during fetch:', error);
  }
}


 const buttonStatus = reactive({
    exportControlSheetLoading: false,
    exportOverviewSheetLoading: false
  });

// JWT
const getJ = async()=>{
  const { data: jwt, execute: getJwt } = await useApi<any>(createUrl('/tca/file/get', {}))
  return jwt
}
//管控表下載
const exportControlSheet= async () => {
  buttonStatus.exportControlSheetLoading = true;
  try {
    let year = filters.year?filters.year:new Date().getFullYear()
    let event = filters.event?filters.event:null
    // const jwt=await getJ(); //取得JWT
    const apiUrl='/tca/budgetSchedule/exportControlSheet'
    await $api(apiUrl, {
      method: 'POST',
      body: {
        belongYear: year,
        scheType: event,
      },
    }).then(async(response) => {
      if(!response?.data?.fileId){
        throw new Error('File ID is undefined');
      }
      const url = await mapFileDownload(fileUrl, response.data.fileId)
      window.open(url,'_blank');
      // console.log("response",response);
      // let url = `${fileUrl}/api/v2/files/nstc/${response.data.fileId}?drJwt=${jwt.value}`;
      // window.open(url,'_blank');
      buttonStatus.exportControlSheetLoading = false;
    });
  } catch (error) {
    popSwal('error','下載管控表失敗',error)
    buttonStatus.exportControlSheetLoading = false;
  }
};

const exportOverviewSheet= async () => {
  buttonStatus.exportOverviewSheetLoading = true;
  try {
    const apiUrl='/tca/budgetSchedule/exportOverviewSheet'
    await $api(apiUrl, {
      method: 'GET',
      query:{
        belongYear:filters.year??new Date().getFullYear(),
      },
    }).then(async(response) => {
      if(!response?.data?.fileId){
        throw new Error('File ID is undefined');
      }
      const url = await mapFileDownload(fileUrl, response.data.fileId)
      window.open(url,'_blank');
      // var fileURL = window.URL.createObjectURL(new Blob([response]));
      // var fileLink = document.createElement('a');
      // fileLink.href = fileURL;
      // fileLink.setAttribute('download', '協會經費需求申請概況表_'+new Date().getTime()+'.xlsx');
      // document.body.appendChild(fileLink);
      // fileLink.click();
      buttonStatus.exportOverviewSheetLoading = false;
    });
  } catch (error) {
    popSwal('error','下載概況表失敗',error)
    buttonStatus.exportOverviewSheetLoading = false;
  }
};
onMounted(()=>{
  getBudgetSchedule()
})
watch(filters, ()=>{
  getBudgetSchedule()
})
</script>

<style scoped>
.v-data-table {
  width: 100%;
}
</style>
